import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend
);

const DailyActivityChart = ({ data, selectedmonth, selectedyear }) => {
    const labels = data.map((d) => {
        const date = new Date(selectedyear, selectedmonth - 1, d.day);

        const dayLetter = date
            .toLocaleDateString("en-US", { weekday: "short" })
            .charAt(0);

        return [d.day.toString(), dayLetter];
    });

    const chartData = {
        labels,
        datasets: [
            {
                type: "bar",
                label: "Failed",
                data: data.map((d) => d.failed),
                backgroundColor: "#FF6666",
                borderColor: "#C0392B",
                borderWidth: { top: 2, left: 0, right: 0, bottom: 0 },
                barPercentage: 0.6,
                categoryPercentage: 0.6,
                stack: "workflow",
            },
            {
                type: "bar",
                label: "In Progress",
                data: data.map((d) => d.inprogress),
                backgroundColor: "#FFD966",
                borderColor: "#F0B429",
                borderWidth: { top: 2, left: 0, right: 0, bottom: 0 },
                barPercentage: 0.6,
                categoryPercentage: 0.6,
                stack: "workflow",
            },
            {
                type: "bar",
                label: "Success",
                data: data.map((d) => d.success),
                backgroundColor: "#68CC97",
                borderColor: "#27AE60",
                borderWidth: { top: 2, left: 0, right: 0, bottom: 0 },
                barPercentage: 0.6,
                categoryPercentage: 0.6,
                stack: "workflow",
            },
            {
                type: "line",

                label: "Cost",
                data: data.map((d) => d.cost),
                yAxisID: "yCost",

                borderColor: "#2B8DC8",
                borderWidth: 1.184,
                tension: 0,

                pointRadius: 4,
                pointHoverRadius: 5,
                pointBackgroundColor: "#ffffff",
                pointBorderColor: "#2B8DC8",
                pointBorderWidth: 1,

                fill: true,
                backgroundColor: (context) => {
                    const ctx = context.chart.ctx;
                    const gradient = ctx.createLinearGradient(0, 0, 0, 300);
                    gradient.addColorStop(0, "rgba(43, 141, 200, 0.30)");
                    gradient.addColorStop(1, "rgba(43, 141, 200, 0.05)");
                    return gradient;
                },
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "index",
            intersect: false,
        },
        plugins: {
            legend: {
                position: "bottom",
                labels:
                {
                    boxWidth: 12,
                    boxHeight: 12,
                }
            },
            tooltip: {
                callbacks: {
                    label: function (ctx) {
                        if (ctx.dataset.type === "line") {
                            return `Cost: $${ctx.raw}`;
                        }
                        return `${ctx.dataset.label}: ${ctx.raw}`;
                    },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: "Day of Month",
                },
                ticks: {
                    color: function (context) {
                        const day = Number(
                            context.chart.data.labels[context.index][0]
                        );

                        const date = new Date(
                            selectedyear,
                            selectedmonth - 1,
                            day
                        );

                        const weekDay = date.getDay(); // 0 = Sunday, 6 = Saturday

                        return weekDay === 0 || weekDay === 6
                            ? "#ff0000"
                            : "#0e0d0d";
                    }
                }
            },
            y: {
                stacked: true,
                beginAtZero: true,
                title: {
                    display: true,
                    text: "Workflow Runs",
                },
            },
            yCost: {
                beginAtZero: true,
                position: "right",
                grid: {
                    drawOnChartArea: false,
                },
                title: {
                    display: true,
                    text: "Cost ($)",
                },
            },
        },
    };

    return (
        <>
            <Chart type="bar" data={chartData} options={options} />
        </>
    );
};

export default DailyActivityChart;
